import {
  type CacheableExternalResource,
  CallState,
} from "@b2bportal/core-types";
import type { ThunkErrorType } from "@b2bportal/core-utilities";
import type {
  PackageFlightShopResponse,
  PackageFlightTripDetailResponse,
} from "@b2bportal/packages-api";
import { createSlice } from "@reduxjs/toolkit";
import { fetchPackageFlights } from "./thunks";
import { fetchPackageFlightsTripDetail } from "./thunks/fetchPackageFlightsTripDetail";

export type PackageFlightShopState = {
  shop: CacheableExternalResource<
    PackageFlightShopResponse,
    ThunkErrorType<{ error: string }>
  >;
  tripDetail: CacheableExternalResource<
    PackageFlightTripDetailResponse,
    ThunkErrorType<{ error: string }>
  >;
};

export type PackageFlightState = PackageFlightShopState;

const initialFlightState: PackageFlightState = {
  shop: { state: CallState.NotCalled },
  tripDetail: { state: CallState.NotCalled },
};

export const packageFlightSlice = createSlice({
  name: "package/flights",
  initialState: initialFlightState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageFlights.pending, (state) => {
        state.shop.state = CallState.InProcess;
      })
      .addCase(fetchPackageFlights.fulfilled, (state, action) => {
        state.shop.state = CallState.Success;
        state.shop.data = action.payload;
      })
      .addCase(fetchPackageFlights.rejected, (state) => {
        state.shop.state = CallState.Failed;
      })
      .addCase(fetchPackageFlightsTripDetail.pending, (state) => {
        state.tripDetail.state = CallState.InProcess;
      })
      .addCase(fetchPackageFlightsTripDetail.fulfilled, (state, action) => {
        state.tripDetail.state = CallState.Success;
        state.tripDetail.data = action.payload;
      })
      .addCase(fetchPackageFlightsTripDetail.rejected, (state) => {
        state.tripDetail.state = CallState.Failed;
      });
  },
});

export const PackageFlightActions = packageFlightSlice.actions;

export default packageFlightSlice.reducer;
